import {CLEAR_NOTIFICATION, LOGOUT_USER} from '../constants/Constants';
import Immutable from 'immutable';

const initialState = Immutable.Map({'notificationId': 0, 'actions': Immutable.Map()}); //eslint-disable-line new-cap

export default function NotificationStore(state = initialState, action = null){
  if(action.text && action.level && action.type !== CLEAR_NOTIFICATION){
    let notificationId = state.get('notificationId');
    action.notificationId = notificationId;
    return state.withMutations(map => {
      map.set('notificationId', notificationId + 1);
      map.setIn(['actions', notificationId], action);
    });
  }else if(action.type === CLEAR_NOTIFICATION){
    return state.deleteIn(['actions', action.notificationId]);
  }else if(action.type === LOGOUT_USER){
    return initialState;
  }
  return state;
}



// WEBPACK FOOTER //
// /src/reducers/NotificationReducer.js